import { render, staticRenderFns } from "./OperateLabelTitle.vue?vue&type=template&id=6e20eaaa"
import script from "./OperateLabelTitle.vue?vue&type=script&lang=js"
export * from "./OperateLabelTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports